import { put, call } from 'redux-saga/effects';
import { authenticateUser } from 'auth/sagas';
import { setRedirect } from 'auth/actions';
import { sprintSubscription, bypassedSubscription, quickSubscription } from 'app/routes';

export function* sprintSubscriptionNavigate({ subId }) {
  yield put(setRedirect(sprintSubscription(subId)));
  yield call(authenticateUser);
}

export function* bypassedSubscriptionNavigate({ subId }) {
  yield put(setRedirect(bypassedSubscription(subId)));
  yield call(authenticateUser);
}

export function* quickSubscriptionNavigate({ subId }) {
  yield put(setRedirect(quickSubscription(subId)));
  yield call(authenticateUser);
}
